export default __webpack_public_path__ + "static/media/instructions.14951509.png";